import { keepPreviousData } from '@tanstack/react-query';

import { GenericFailure } from '@playq/services-shared';
import { UnconfiguredMetrics } from '@playq/services-taxman';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const corpBillingUnconfiguredQueryKeys: unknown[] = ['corp', 'admin', 'billing', 'unconfigured', 'query'];

export const useAdminBillingUnconfiguredQuery = (
  options?: IUseQueryOptionsExtended<UnconfiguredMetrics | undefined, GenericFailure | Error>
) => {
  return useEitherQuery(corpBillingUnconfiguredQueryKeys, () => services2.adminBillingService.getUnconfigured(), {
    placeholderData: keepPreviousData,
    ...options,
  });
};
